
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/biz",
      function () {
        return require("private-next-pages/biz/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/biz"])
      });
    }
  